// @ is an alias to /src
import { firebase, auth, db } from '@/firebase.js';
// import { firebase, auth, firestore, db } from '@/firebase.js';
import icabody from '@/icabody.js'
import _ from 'lodash'
import moment from 'moment'

const debug = false;
const name = 'store/modules/usersProjects.js';

const state = {
  isAddingUserToProject: false,
  userProjects: [], // joined projects list
  userProject: null, // selected userProject for view
  // unlockedProjects: [], // unlocked and joinable projects list
  currentProject: null, // current selected project in userProject (used to check if survey is enabled)
  isReadingProjects: false,
  isSavingAnswerToUserProject: false,
}

const getters = {}

const mutations = {
  /**
   * setUserToProjectAdding mutation
   * @param value Boolean
   */
  setUserToProjectAdding (state, value) {
    if (debug) console.log(name,'mutation setUserToProjectAdding() value:',value)
    state.isAddingUserToProject = value
  },

  /**
   * setUserProjects mutation
   * @param userProjects Array of userProjects
   */
  setUserProjects (state, userProjects) {
    if (debug) console.log(name,'mutation setUserProjects() userProjects:',userProjects);
    state.userProjects = userProjects;
  },

  /**
   * setUnlockedProjects mutation
   * @param unlockedProjects Array of unlocked projects
   */
  /*
  setUnlockedProjects (state, unlockedProjects) {
    if (debug) console.log(name,'mutation setUnlockedProjects() unlockedProjects:',unlockedProjects);
    state.unlockedProjects = unlockedProjects;
  },
  */

  /**
   * setUserProject mutation
   * @param userProjects Object with userProject
   * }
   */
  setUserProject (state, userProject) {
    if (debug) console.log(name,'mutation setUserProject() userProject:',userProject);
    state.userProject = userProject;
  },

  /**
   * setUserProjectById mutation
   * @param projectId String
   */
  setUserProjectById (state, projectId) {
    if (debug) console.log(name,'mutation setUserProjectById() projectId:',projectId)
    let userProjectFound = state.userProjects.find((userProject) => {
      return userProject.projectId === projectId
    })
    if (debug) console.log(name,'mutation setUserProjectById() userProjectFound:',userProjectFound)
    if (userProjectFound) {
      state.userProject = userProjectFound
    }
  },

  /**
   * setCurrentProject mutation
   * @param project Object with project
   * }
   */
  setCurrentProject (state, project) {
    if (debug) console.log(name,'mutation setCurrentProject() project:',project);
    state.currentProject = project;
  },

  /**
   * setProjectReading mutation
   * @param value Boolean
   */
  setProjectReading (state, value) {
    if (debug) console.log(name,'mutation setProjectReading() value:',value);
    state.isReadingProjects = value;
  },

  /**
   * setAnswerToUserProjectSaving mutation
   * @param value Boolean
   */
  setAnswerToUserProjectSaving (state, value) {
    if (debug) console.log(name,'mutation setAnswerToUserProjectSaving() value:',value);
    state.isSavingAnswerToUserProject = value;
  },

  /**
   * updateProject mutation
   * @param updateData data to upgrade in userProject
   */
  updateUserProject (state, updateData) {
    if (debug) console.log(name,'mutation updateUserProject() updateData:',updateData);
    // Overwrite updateData to state.userProject
    if (debug) console.log(name,'mutation updateUserProject() -1- state.userProject:',state.userProject);
    for (let key in updateData) {
      if(!Object.prototype.hasOwnProperty.call(updateData, key)) continue;
      state.userProject[key] = updateData[key]
    }
    if (debug) console.log(name,'mutation updateUserProject() -2- state.userProject:',state.userProject);
  }
}

const actions = {
  /**
   * addUserToProject action
   * @param data { project: String, password: String }
   * @returns Promise
   */
  async addUserToProject ({ commit }, data) {
    if (debug) console.log(name,'action addUserToProject() data:',data,'project:',data.project,'password:',data.password,'uid:',auth.currentUser.uid);
    if (data.project.password !== data.password) {
      console.log(name,'action addUserToProject() Wrong password');
      // reject('Wrong password');
      // return;
      throw 'Wrong password';
    }
    console.log(name,'action addUserToProject() Add user to project...');
    commit('setUserToProjectAdding', true);

    if (debug) console.log(name,'action addUserToProject() call firebase function "addUserToProject"...')
    const addUserToProject = firebase.functions().httpsCallable('addUserToProject');
    try {
      const result = await addUserToProject(data.project.id);
      if (debug) console.log(name,'action addUserToProject() result:', result);
      commit('setUserToProjectAdding', false);
      return;
      // resolve();
    }
    catch (error) {
      if (debug) console.log(name,'action addUserToProject() error:', error);
      commit('setUserToProjectAdding', false);
      // reject(error);
      throw error;
    }
  },

  /**
   * readUnlockedProjects action
   * @returns Promise
   */
  /*
  readUnlockedProjects ({ commit }) {
    return new Promise((resolve) => {
      if (debug) console.log(name,'action readUnlockedProjects()');
      let unsubscribe = db.collection('projects').where("locked", "==", false)
      .onSnapshot((querySnapshot) => {
        let projects = []
        if (debug) console.log(name,'action readUnlockedProjects() querySnapshot:',querySnapshot)
        querySnapshot.forEach((document) => {
          let data = document.data()
          data.id = document.id
          projects.push(data)
        })
        if (debug) console.log(name,'action readUnlockedProjects() projects:',projects)
        commit('setUnlockedProjects', projects)
      }, (error) => {
        if (debug) console.log(name,'action readUnlockedProjects() error:',error)
      })
      resolve(unsubscribe)
    })
  },
  */

  /**
   * readMyUserProjects action
   * @returns Promise
   */
  readMyUserProjects ({ commit }) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name,'action readMyUserProjects()');
      commit('setProjectReading', true)
      db.collection('usersProjects').where("userId", "==", auth.currentUser.uid).get()
      .then((querySnapshot) => {
        let userProjects = []
        if (debug) console.log(name,'action readMyUserProjects() querySnapshot:',querySnapshot)
        // Map results to execute promises for each documents
        let documentsArr = []
        querySnapshot.forEach((document) => {
          documentsArr.push(document.data())
        })
        let promiseArr = documentsArr.map((userProject) => {
          if (debug) console.log(name,'action readMyUserProjects() read userProject.projectId:',userProject.projectId,'...')
          // Read each project
          return new Promise((resolve) => {
            db.collection('projects').doc(userProject.projectId).get()
            .then((document) => {
              if (document.exists) {
                let project = document.data()
                if (debug) console.log(name,'action readMyUserProjects() userProject.projectId:',userProject.projectId,'project:',project)
                userProjects.push({
                  projectId: document.id,
                  title: project.title,
                  createDate: project.createDate,
                  joinedDate: userProject.createDate,
                  surveys: userProject.surveys
                })
                resolve()
              }
              else {
                if (debug) console.log(name,'action readMyUserProjects() userProject.projectId=',userProject.projectId,'doesn\'t exists')
              }
            })
            .catch((error) => {
              if (debug) console.log(name,'action readMyUserProjects() reading userProject.projectId=',userProject.projectId,' error:',error)
            })
          })
        })
        return Promise.all(promiseArr)
        .then(() => {
          if (debug) console.log(name,'action readMyUserProjects() userProjects:',userProjects)
          commit('setUserProjects', userProjects)
          commit('setProjectReading', false)
          resolve()
        })
      })
      .catch((error) => {
        if (debug) console.log(name,'action readMyUserProjects() userProjects error:',error)
        commit('setProjectReading', false)
        reject(error.message)
      })
    })
  },

  /**
   * readCurrentProject action
   * used to read selected project to check if survey is enabled
   * @returns Promise
   */
  readCurrentProject ({ commit }, data) {
    return new Promise((resolve) => {
      if (debug) console.log(name,'action readCurrentProject() data:', data);
      if (debug) console.log(name,'action readCurrentProject() data.id:', data.id);
      if (!data.id) {
        if (debug) console.log(name,'action readCurrentProject() setCurrentProject null');
        return commit('setCurrentProject', null)
      }
      let unsubscribe = db.collection('projects').doc(data.id)
      .onSnapshot((document) => {
        if (debug) console.log(name,'action readCurrentProject() document:',document)
        if (debug) console.log(name,'action readCurrentProject() currentProject = document.data():',document.data())
        commit('setCurrentProject', document.data())
      }, (error) => {
        if (debug) console.log(name,'action readCurrentProject() error:',error)
      })
      resolve(unsubscribe)
    })
  },

  /**
   * saveAnswerToUserProject action
   * @param data { step: Number, area: Number, value: Number }
   * @returns Promise
   */
  saveAnswerToUserProject ({ state, commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      if (debug) console.log(name,'action saveAnswerToUserProject() data:',data,'step:',data.step,'areaIndex:',data.areaIndex,'value:',data.value,'projectId:',state.userProject.projectId,'uid:',auth.currentUser.uid,'icabody.getMaxSurveysForUserProject():',icabody.getMaxSurveysForUserProject())
      if (!state.userProject || !state.userProject.projectId) {
        reject('User project not set')
        return
      }
      if (!auth.currentUser || !auth.currentUser.uid) {
        reject('User not logged')
        return
      }
      if (!('step' in data)) {
        reject('Data error')
        return
      }
      if (data.step < 1 || data.step > 3) {
        reject('Invalid step')
        return
      }
      if (data.step !== 3 && (!('areaIndex' in data) || !('value' in data))) {
        reject('Data error')
        return
      }
      if (debug) console.log(name,'action saveAnswerToUserProject() current userProject:',state.userProject)
      if (debug) console.log(name,'action saveAnswerToUserProject() current surveys.length:',state.userProject.surveys.length)
      // Set surveys
      let surveys = _.cloneDeep(state.userProject.surveys)
      if (debug) console.log(name,'action saveAnswerToUserProject() current surveys:',state.userProject.surveys.length)
      if (debug) console.log(name,'action saveAnswerToUserProject() clonedSurveys:',surveys)
      // Get the survey's index
      let surveyIndex = 0
      for (let i = 0; i < icabody.getMaxSurveysForUserProject(); i++) {
        // fix survey empty
        if (!surveys[i]) {
          let survey = {
            completed: false,
            answers: []
          }
          // init answers
          icabody.getChartAreas().forEach((element, index) => {
            survey.answers.push({
              order: index + 1,
              area: element
            })
          })
          surveys.push(survey)
        }
        if (surveys[i].completed) {
          surveyIndex = i + 1
        }
      }
      if (surveyIndex > icabody.getMaxSurveysForUserProject()) {
        reject('You have reached the max number of suvey for this project')
        return
      }
      if (debug) console.log(name,'action saveAnswerToUserProject() --- surveyIndex:',surveyIndex)
      let survey = surveys[surveyIndex]
      if (debug) console.log(name,'action saveAnswerToUserProject() --- survey',survey)
      /*
      if (surveys.length > 0) {
        if (debug) console.log(name,'action saveAnswerToUserProject() --- surveys[surveys.length - 1]:',surveys[surveys.length - 1])
        if (debug) console.log(name,'action saveAnswerToUserProject() --- surveys[surveys.length - 1].completed:',surveys[surveys.length - 1].completed)
      }
      if (surveys.length > 0 && !surveys[surveys.length - 1].completed) {
        // get not finished survey
        if (debug) console.log(name,'action saveAnswerToUserProject() --- continued old not finished survey index:',(surveys.length-1))
        survey = surveys[surveys.length - 1]
      }
      else {
        // create new survey
        if (debug) console.log(name,'action saveAnswerToUserProject() --- create new survey')
        survey = {
          completed: false,
          answers: []
        }
        // init answers
        icabody.getChartAreas().forEach((element, index) => {
          survey.answers.push({
            order: index + 1,
            area: element
          })
        })
        surveys.push(survey)
      }
      if (debug) console.log(name,'action saveAnswerToUserProject() -1- survey:',survey)
      if (debug) console.log(name,'action saveAnswerToUserProject() -1- surveys:',surveys)
      */

      // Check step 1 & 2
      if (data.step === 1 || data.step === 2) {

        if (data.areaIndex < 0 || data.areaIndex >= survey.answers.length) {
          reject('Invalid area index')
          return
        }
        let givenReceivedName = (data.step === 1 ? 'given' : 'received')
        // check current answer
        if (debug) console.log(name,'action saveAnswerToUserProject() ****** givenReceivedName:',givenReceivedName,'data.areaIndex:',data.areaIndex)
        if (debug) console.log(name,'action saveAnswerToUserProject() ****** survey.answers[data.areaIndex]:',survey.answers[data.areaIndex])
        if (debug) console.log(name,'action saveAnswerToUserProject() ****** survey.answers[data.areaIndex]["given"]:',survey.answers[data.areaIndex]['given'])
        if (debug) console.log(name,'action saveAnswerToUserProject() ****** survey.answers[data.areaIndex]["received"]:',survey.answers[data.areaIndex]['received'])
        if (debug) console.log(name,'action saveAnswerToUserProject() ****** survey.answers[data.areaIndex][givenReceivedName]:',survey.answers[data.areaIndex][givenReceivedName])
        if (debug) console.log(name,'action saveAnswerToUserProject() ****** survey.answers:',(survey.answers ? true : false))
        if (debug) console.log(name,'action saveAnswerToUserProject() ****** survey.answers[data.areaIndex]:',(survey.answers[data.areaIndex] ? true : false))
        if (debug) console.log(name,'action saveAnswerToUserProject() ****** (givenReceivedName in survey.answers[data.areaIndex]):',((givenReceivedName in survey.answers[data.areaIndex]) ? true : false))
        if (survey.answers && survey.answers[data.areaIndex] && (givenReceivedName in survey.answers[data.areaIndex]) ) {
          reject('Current answer already completed. Please, reload the page.')
          return
        }
        // check previous answer
        if (data.areaIndex > 0 && data.step <= 2) {
          if ( !(givenReceivedName in survey.answers[data.areaIndex - 1]) ) {
            reject('Previous answer not completed. Please, reload the page.')
            return
          }
        }
        if (data.areaIndex == 0 && data.step == 2 && !('given' in survey.answers[survey.answers.length - 1])) {
          reject('Previous answer not completed. Please, reload the page.')
          return
        }
        survey.answers[data.areaIndex][givenReceivedName] = data.value
        if (debug) console.log(name,'action saveAnswerToUserProject() -2- survey:',survey)
        if (debug) console.log(name,'action saveAnswerToUserProject() -2- surveys:',surveys)
        let updateData = {
          surveys
        }
        if (debug) console.log(name,'action saveAnswerToUserProject() *** updateData:',updateData)
        if (debug) console.log(name,'action saveAnswerToUserProject() *** path: usersProjects/' + auth.currentUser.uid + state.userProject.projectId)
        // updateData['surveys.' + state.userProject.surveys.length] = {}
        //   data.area: [],
        // }
        // if (debug) console.log(name,'action saveAnswerToUserProject() updateData:',updateData);
        commit('setAnswerToUserProjectSaving', true)
        db.collection('usersProjects').doc(auth.currentUser.uid + state.userProject.projectId)
        .update(updateData)
        .then(() => {
          if (debug) console.log(name,'action saveAnswerToUserProject() answer added')
          commit('updateUserProject', updateData)
          if (debug) console.log(name,'action saveAnswerToUserProject() answer added ******* state.userProject:',state.userProject)
          if (debug) console.log(name,'action saveAnswerToUserProject() answer added ******* state.userProjects:',state.userProjects)
          commit('setAnswerToUserProjectSaving', false)
          resolve()
        })
        .catch((error) => {
          if (debug) console.warn(name,'action saveAnswerToUserProject() adding answer error:',error)
          commit('setAnswerToUserProjectSaving', false)
          reject(error)
        })

      }
      // Check step 3
      else if (data.step === 3) {

        // check the user Project completed
        if (!survey.answers) {
          reject('Error in survey')
          return
        }
        let surveyCompleted = true
        survey.answers.forEach((element) => {
          if (this.debug) console.log(name+'.action saveAnswerToUserProject() --- element:',element)
          if ( !('received' in element)  || !('given' in element) ) {
            surveyCompleted = false
          }
        })
        if (!surveyCompleted) {
          reject('Survey not completed. Please, reload the page.')
          return
        }
        // Update user data
        let userData = {
          displayName: data.displayName,
          nickname: data.nickname,
          email: data.email,
          gender: data.gender,
          yearOfBirth: data.yearOfBirth,
          education: data.education,
          position: data.position
        }
        if (debug) console.log(name,'action saveAnswerToUserProject() update user with data:',userData)
        commit('setAnswerToUserProjectSaving', true)
        dispatch('auth/updateUser', userData, {root:true})
        .then(() => {
          survey.completed = true
          survey.nickname = data.nickname
          survey.createDate = moment().format()
          let updateData = { surveys }
          if (debug) console.log(name,'action saveAnswerToUserProject() user updated. Update surveys: updateData:',updateData)
          return db.collection('usersProjects').doc(auth.currentUser.uid + state.userProject.projectId)
          .update(updateData)
          .then(() => {
            if (debug) console.log(name,'action saveAnswerToUserProject() surveys update with survey.completed = true !!!!!!!!!')
            commit('updateUserProject', updateData)
            commit('setAnswerToUserProjectSaving', false)
            resolve()
          })
        })
        .catch((error) => {
          if (debug) console.log(name,'action saveAnswerToUserProject() error user:',error)
          commit('setAnswerToUserProjectSaving', false)
          reject(error)
        })

      }
      else {
        reject('Invalid step')
        return
      }
    })
  }

}

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions
}
/*
[
  {
    completed: true,
    answers: [
      {
        order: 1,
        area: '1 Spiritual life',
        given: 0,
        received: 0
      },
      {
        order: 2,
        area: '2 Cultural update',
        given: 0,
        received: 0
      },
      {
        order: 3,
        area: '3 Professional update',
        given: 0,
        received: 0
      },
      {
        order: 4,
        area: '4 Social life + Friends',
        given: 0,
        received: 0
      },
      {
        order: 5,
        area: '5 Work',
        given: 0,
        received: 0
      },
      {
        order: 6,
        area: '6 Children',
        given: 0,
        received: 0
      },
      {
        order: 7,
        area: '7 Love',
        given: 0,
        received: 0
      },
      {
        order: 8,
        area: '8 Body + Health care',
        given: 0,
        received: 0
      },
      {
        order: 9,
        area: '9 Sexual life',
        given: 0,
        received: 0
      },
      {
        order: 10,
        area: '10 Food',
        given: 0,
        received: 0
      },
      {
        order: 11,
        area: '11 Sleep',
        given: 0,
        received: 0
      },
      {
        order: 12,
        area: '12 Home',
        given: 0,
        received: 0
      },
      {
        order: 13,
        area: '13 Family of origin',
        given: 0,
        received: 0
      },
      {
        order: 14,
        area: '14 Financial stability',
        given: 0,
        received: 0
      }
    ]
  },
  {
    completed: true,
    answers: [
      {
        order: 1,
        area: '1 Spiritual life',
        given: 0,
        received: 0
      }
    ]
  }
]
*/